<template>
  <div class="story-meta">
    {{ story.category }} - Rated: {{ story.rating }} - {{ story.language }} -
    {{ story.genre }}<template v-if="story.subgenre_id > 0">/{{ story.subgenre }}</template> -
    Chapters: {{ story.chapters }} - Words: {{ story.words }} -
    Updated: {{ story.date_updated }} - Published: {{ story.date_posted }} {{ story.charactors }}
    <template v-if="story.status_id == 2">- Completed</template>
  </div>
</template>
<style>
  .story-meta { font-size: 80%; color:#666666}
</style>
<script>
export default {
  props: ['story'],
};
</script>



/** WEBPACK FOOTER **
 ** StorySmallMeta.vue?670b43bb
 **/